import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

import Axios from "../../services/axios";

export const getStaffData = createAsyncThunk(
  "getStaff",
  async (payload, { rejectWithValue }) => {
    try {
      if (payload?.filters?.role === "Rcm Assistant") {
        payload.filters.role = "Rcm_Assistant";
      }
      if (payload?.filters?.role === "Call Center") {
        payload.filters.role = "Call_Center";
      }
      const response = await Axios.post(`/v3/staff/getList`, payload);
      return response.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const createNewStaff = createAsyncThunk(
  "createUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post("/v3/staff/create", payload);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const updateStaffData = createAsyncThunk(
  "updateUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post("/v3/staff/update", payload);
      toast.success(response?.data?.message);
      return response?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const deleteStaffData = createAsyncThunk(
  "deleteUser",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post("/v3/staff/delete", payload);
      return response?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const updateStaffStatus = createAsyncThunk(
  "updateStaffStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post(`/v3/staff/status`, payload);
      return response?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.message || "Error");
    }
  }
);

export const getStaffRolesList = createAsyncThunk(
  "getUserRoles",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await Axios.post("/v3/role/getList", payload);
      return response?.data;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Error"
      );
      return rejectWithValue(error?.response?.data?.error || "Error");
    }
  }
);

const initialState = {
  isLoading: false,
  StaffData: null,
};

const StaffSlice = createSlice({
  name: "staff",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getStaffData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getStaffData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.StaffData = action.payload;
      })
      .addCase(getStaffData.rejected, (state) => {
        state.isLoading = false;
        state.StaffData = null;
      });
  },
});

export default StaffSlice.reducer;
